module.exports = __webpack_public_path__ + "assets/img/2813.47743f10.png";